import type { JSX } from 'react';

import isotypeSrc from '../assets/brand/punta-norte-isotype.png';
import wordmarkSrc from '../assets/brand/punta-norte-wordmark.png';
import { cn } from '../lib/cn';

export type BrandLogoVariant = 'wordmark' | 'isotype';
export type BrandLogoSize = 'sm' | 'md' | 'lg';

export interface BrandLogoProps {
  /** `wordmark` is the horizontal logo; `isotype` the compact circular one. */
  variant?: BrandLogoVariant;
  size?: BrandLogoSize;
  className?: string;
}

const SOURCES: Record<BrandLogoVariant, string> = {
  wordmark: wordmarkSrc,
  isotype: isotypeSrc,
};

/** Written out in full: Tailwind cannot see class names built at runtime. */
const SIZE_STYLES: Record<BrandLogoSize, string> = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-14',
};

/** The client's logo. Width follows the intrinsic aspect ratio of the variant. */
export function BrandLogo({
  variant = 'wordmark',
  size = 'sm',
  className,
}: BrandLogoProps): JSX.Element {
  return (
    <img
      src={SOURCES[variant]}
      alt="Punta Norte"
      data-variant={variant}
      className={cn('w-auto select-none', SIZE_STYLES[size], className)}
    />
  );
}
